import React from 'react';
import ReactDOM from 'react-dom/client';
import { SpeedInsights } from '@vercel/speed-insights/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const blockPageInteraction = (event: Event) => {
  event.preventDefault();
};

document.addEventListener('contextmenu', blockPageInteraction);
document.addEventListener('dragstart', blockPageInteraction);
document.addEventListener('selectstart', blockPageInteraction);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <>
    <App />
    <SpeedInsights />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
